module.exports = __webpack_public_path__ + "img/AXIS Logo for Light Backgrounds.65e96d31.png";